import { render, staticRenderFns } from "./ServiceItemPortraitLineOne.vue?vue&type=template&id=a2993e9c&scoped=true&"
import script from "./ServiceItemPortraitLineOne.vue?vue&type=script&lang=js&"
export * from "./ServiceItemPortraitLineOne.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItemPortraitLineOne.vue?vue&type=style&index=0&id=a2993e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2993e9c",
  null
  
)

export default component.exports